import { useState, useEffect, useRef } from 'react';

export const useGamepadInput = (gamepadMap) => {
    const [activeButtons, setActiveButtons] = useState({
        dot: false,
        dash: false
    });
    const requestRef = useRef();
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        const scanGamepads = () => {
            const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
            let gp = null;

            // Find the first connected gamepad
            for (let i = 0; i < gamepads.length; i++) {
                if (gamepads[i]) {
                    gp = gamepads[i];
                    break;
                }
            }

            if (gp) {
                if (!isConnected) setIsConnected(true);

                // Check mapped buttons
                // Default to Button 0 (A/Cross) for Dot, Button 1 (B/Circle) for Dash if no map
                const dotBtnIndex = gamepadMap?.dot !== undefined ? gamepadMap.dot : 0;
                const dashBtnIndex = gamepadMap?.dash !== undefined ? gamepadMap.dash : 1;

                const dotPressed = gp.buttons[dotBtnIndex]?.pressed || false;
                const dashPressed = gp.buttons[dashBtnIndex]?.pressed || false;

                if (dotPressed !== activeButtons.dot || dashPressed !== activeButtons.dash) {
                    setActiveButtons({ dot: dotPressed, dash: dashPressed });
                }
            } else {
                if (isConnected) setIsConnected(false);
            }

            requestRef.current = requestAnimationFrame(scanGamepads);
        };

        requestRef.current = requestAnimationFrame(scanGamepads);

        return () => cancelAnimationFrame(requestRef.current);
    }, [isConnected, activeButtons.dot, activeButtons.dash, gamepadMap]);

    return { isGamepadConnected: isConnected, activeButtons };
};
